import { Subject } from 'rxjs';

export const mainKaPloint = new Subject();
export const mainKaPlointModal = new Subject();

export const publish = (data: any) => mainKaPloint.next(data);
export const publishmodal = (data: any) => mainKaPlointModal.next(data);
